// The A/B test script app embed (hvmn-checkout-extensions, ab-test-script) assigns the checkout variant and exposes
// its cart attributes here. Checkout writes add them so they travel in the cart write queue: the embed's own write on
// page load is lost for a visitor without a cart. A failure here must not fail the checkout write.
export const getAbCheckoutCartAttributes = () => {
  try {
    return window.abCheckout?.getCartAttributes() || {};
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error:', error);

    return {};
  }
};
